export class UploadDocument {
  constructor(
    public readonly displayName: string,
    public readonly documentType: string,
    public readonly productId: string,
    public readonly id?: string,
    public readonly uri?: string,
  ) {}
}
